/**
 * @description: 地址管理路由
 */
export default [
  {
    path: '/address/manage',
    name: 'MyAddressManage',
    component: (resolve) => require(['@/views/address/MyAddressManage'], resolve),
    meta: {
      title: '收货地址',
      keepAlive: false // /此组件不需要缓存
    }
  },
  {
    path: '/address/addEdit',
    name: 'AddOrEditAddress',
    component: (resolve) => require(['@/views/address/AddOrEditAddress'], resolve),
    meta: {
      title: '新增收货地址',
      keepAlive: false // /此组件不需要缓存
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/address.js